import React from "react";
import { ButtonContainer } from "./style.js";
const Button = ({ title, onClick, btn, disabled, loading, type }) => {
  return (
    <ButtonContainer
      btn={btn}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
    >
      {title}
    </ButtonContainer>
  );
};
export default Button;
